import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Row, Col, Form } from "react-bootstrap";
import { translationConstants, modeConstants, globalGridActions, emptyString } from "../../../constants";
import { useForm, Controller } from "react-hook-form";
import { allSharedComponents } from "../..";
import { useCallback, useState } from "react";
import { competitionActions } from "../../../redux/actions";
import { convertObjectToFormData } from "../../../system";
import { useDispatch, useSelector } from "react-redux";

const UploadResultsModal = (props) => {
    const {
        setValue,
        getValues,
        register,
        handleSubmit,
        trigger,
        formState: { errors },
        control,
    } = useForm();
    const {
        FileUploader,
        ReactDatePickerWrapper,
        InputFieldWrapper,
        SpinnerContainer,
        MultiSelect,
    } = allSharedComponents;
    const fileData = useSelector(
        (state) => state.CompetitionReducer.uploadedFile
    );
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [document, setDocument] = useState([]);
    const [results, setResults] = useState(fileData);
    const [checkBox, setCheckBox] = useState(results?.link ? false : results?.document ? true : true);
    const [isFileChanged, setIsFileChanged] = useState(false);
    const [validationMessage, setValidationMessage] = useState("");
    const handleFileUpload = useCallback(
        (file, key) => {
            setValue(key, file);
        },
        [setValue]
    );

    const handleCheckboxChange = () => {
        setCheckBox(!checkBox);
    };

    const onSubmit = (data, event) => {
        const dataToSend = {
            id: props.id,
            link: !checkBox ? data?.link : null,
            file: checkBox ? data?.file[0] : null
        }
        setDocument([]);
        const formData = convertObjectToFormData(dataToSend);
        dispatch(competitionActions.uploadFiles(formData));
        props.setShow(!props.show);
    };

    useEffect(() => {
        setResults(fileData);
        if (fileData && fileData?.document) { setDocument([fileData?.document]); }
        else {
            setDocument([])
        }
    }, [fileData])

    useEffect(() => {
        setResults(null);
    }, []);

    return (
        <>
            <div className="ViewHeader">
                <p className="viewUserPara">{t(props.title)}</p>
            </div>
            <p className="horizentalLine" />
            <Form
                noValidate
                className="ViewUserContent"
                onSubmit={handleSubmit(onSubmit)}
            >
                <InputFieldWrapper
                    lg={10}
                    md={12}
                >
                    <Form.Check
                        type="checkbox"
                        id="resultLink"
                        label={<span className={`${!checkBox ? "color-dark" : ""}`}>{t(translationConstants.ENTER_THE_RESULT_LINK)}</span>}
                        checked={!checkBox}
                        onChange={(e) => {

                            handleCheckboxChange();
                        }}
                        className={`upload-form form-check-label`}
                    />
                    <Form.Group className="form-group-register mt-3">
                        <div className="inputWithoutOutline d-flex justify-content-center align-items-center upload-field">
                            <Form.Control
                                {...register("link", !checkBox ? {
                                    required: t(
                                        translationConstants.URL_IS_REQUIRED
                                    ),
                                } : { required: false })}
                                value={results?.link}
                                onChange={(e) => {
                                    setValue("link", e.target.value);
                                    trigger("link");
                                }}
                                id="link"
                                type="text"
                                placeholder="www.resultsloremipsum.sa"
                                disabled={checkBox}
                            />
                        </div>
                    </Form.Group>
                    {errors?.link && !checkBox && (
                        <p className="errorText">{errors?.link.message}</p>
                    )}
                </InputFieldWrapper>

                <InputFieldWrapper
                    lg={10}
                    md={12}
                >
                    <Form.Check
                        type="checkbox"
                        id="publicCompetitionType"
                        label={<span className={`${checkBox ? "color-dark" : ""}`}>{t(translationConstants.UPLOAD_RESULT_DOCUMENT)}</span>}
                        className={`upload-form form-check-label`}
                        checked={checkBox}
                        onChange={(e) => {
                            handleCheckboxChange();
                        }}
                    />
                    <div className="filterUploader upload-field mt-3 uploads result-upload">
                        <FileUploader
                            sm
                            single
                            disabled={!checkBox}
                            {...register("file",
                                checkBox ? {
                                    required: t(
                                        translationConstants.FILE_IS_REQUIRED
                                    ),
                                } : { required: false })}
                            defaultValue={
                                document
                            }
                            onFileUpload={(file) => handleFileUpload(file, "file")}
                            setValidationErrorMessage={setValidationMessage}
                            onChangeFlag={setIsFileChanged}
                            className=""
                        // isAllowPreview={props.mode === modeConstants.VIEW_MODE}
                        />
                        {errors.file && checkBox && (
                            <p className="errorText">{errors.file.message}</p>
                        )}
                    </div>
                </InputFieldWrapper>
                <div className="d-block d-sm-flex align-items-center justify-content-center my-5 mb-1">
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <Button
                                className="approve-button mx-1 "
                                type="submit"
                            >
                                {t(translationConstants.submit)}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Form>
        </>
    );
};

export default UploadResultsModal;
